// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__19-pl","loaderOuter":"PageOverlayLoader_loaderOuter__fVrCF"};